import api from "@apiClient";
import { CircularProgress, Tab, Tabs, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import CommunityGroupsTab from "./community-detail-tabs/CommunityGroupsTab";
import CommunityMembersTab from "./community-detail-tabs/CommunityMembersTab";
import CommunityEngagementTab from "./community-detail-tabs/CommunityEngagementTab";

export default function CommunityDetail({ id, setId, setCommunitiesReload }) {
  const [community, setCommunity] = useState(null);
  const [tabValue, setTabValue] = useState(0);

  const handleChangeTab = (event, newVal) => {
    setTabValue(newVal);
  };

  const fetchData = useCallback(() => {
    if (!id) return;
    api
      .getCommunityDetail(id)
      .then(setCommunity)
      .catch(() => {});
  }, [id]);

  useEffect(() => {
    if (id) fetchData();
  }, [id, fetchData]);

  if (!community) return <CircularProgress />;

  // Declaring this and passing to child components to arrange relative to child component
  const PassedTabs = (
    <Tabs value={tabValue} onChange={handleChangeTab}>
      <Tab label="Engagement" value={2} />
      <Tab label="Groups" value={0} />
      <Tab label="Members" value={1} />
    </Tabs>
  );

  return (
    <div className="mx-12">
      {/* <div className="mx-12">
        <div className="px-5 py-1 flex justify-end">
          <Typography className="font-semibold text-gray-400 text-sm">
            Total resurfaced posts: {community?.totalResurfacedPosts || 0}
          </Typography>
        </div>
      </div> */}
      {tabValue === 0 && (
        <CommunityGroupsTab
          id={id}
          setId={setId}
          community={community}
          tabs={PassedTabs}
          communityRefresh={fetchData}
        />
      )}
      {tabValue === 1 && (
        <CommunityMembersTab
          id={id}
          setId={setId}
          community={community}
          tabs={PassedTabs}
          communityRefresh={fetchData}
          setCommunitiesReload={setCommunitiesReload}
        />
      )}
      {tabValue === 2 && (
        <CommunityEngagementTab
          id={id}
          setId={setId}
          community={community}
          tabs={PassedTabs}
          communityRefresh={fetchData}
        />
      )}
    </div>
  );
}
